// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoText_root__mtA_G"};